import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IUser } from '@elyx-code/definitions';
import { CircularProgress } from '@mui/material';
import Logo from '../assets/logo-full-word-white.png';
import { getCurrentUserOrLogoutRedirect } from '../auth';
import { envConfig } from '../config';

const PricingPlans: React.FC = () => {
	const [user, setUser] = useState<IUser>();
	const navigate = useNavigate();

	useEffect(() => {
		const fetchUser = async () => {
			const currentUser = await getCurrentUserOrLogoutRedirect();
			setUser(currentUser);

			// Load the Stripe Pricing Table script dynamically
			const script = document.createElement('script');
			script.src = 'https://js.stripe.com/v3/pricing-table.js';
			script.async = true;
			document.body.appendChild(script);
		};
		fetchUser();
	}, []);

	// Sleek, centered loading state
	if (!user || !user.workspace) {
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
					width: '100%',
				}}
			>
				<CircularProgress sx={{ color: 'var(--color-main-primary)' }} />
			</div>
		);
	}

	return (
		<div
			className='pricing-page'
			style={{
				minHeight: '100vh',
				width: '100%',
				padding: '40px 20px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				// If your app uses a dark theme, change this to a dark hex like #111827.
				// If light, a subtle off-white/gray like #f8f9fc makes the white cards pop.
				backgroundColor: 'var(--color-main-primary, transparent)',
			}}
		>
			{/* Header Section */}
			<div
				style={{
					width: '100%',
					maxWidth: '1200px',
					position: 'relative',
					marginBottom: '48px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				{/* Absolute positioned back button so it doesn't offset the centered title */}
				<button
					onClick={() => navigate(-1)}
					style={{
						position: 'absolute',
						left: 0,
						background: 'none',
						border: 'none',
						cursor: 'pointer',
						fontSize: '1rem',
						color: 'white',
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
						fontWeight: 600,
						padding: '8px 16px',
						borderRadius: '8px',
						transition: 'opacity 0.2s ease',
					}}
					onMouseOver={(e) => (e.currentTarget.style.opacity = '0.7')}
					onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
				>
					<i className='fa-solid fa-arrow-left'></i> Back
				</button>

				<div style={{ textAlign: 'center', color: 'white' }}>
					<h1
						style={{ margin: '0 0 8px 0', fontSize: '2.5rem', fontWeight: 700 }}
					>
						Choose your plan
					</h1>
					<p style={{ margin: 0, fontSize: '1.1rem', opacity: 0.7 }}>
						Select the perfect montly plan for your workspace needs.
					</p>
				</div>
			</div>

			{/* Pricing Table Wrapper */}
			<div
				style={{
					width: '100%',
					maxWidth: '1200px',
					// Optional: Add a subtle shadow to lift the table off the background
					// boxShadow:
					// 	'0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
					borderRadius: '16px',
					overflow: 'hidden', // Keeps the rounded corners crisp
				}}
			>
				{/* @ts-ignore - Custom Web Component */}
				<stripe-pricing-table
					client-reference-id={user.workspace.id}
					customer-email={user.email}
					// @ts-ignore
					pricing-table-id={envConfig.stripe_pricing_table_id}
					// @ts-ignore
					publishable-key={envConfig.stripe_publishable_key} // Note: Swapped to pk_test for safety!
				>
					{/* @ts-ignore */}
				</stripe-pricing-table>
			</div>
			<a
				href='/'
				onClick={(e) => {
					e.preventDefault();
					navigate('/');
				}}
			>
				<img
					style={{
						position: 'absolute',
						bottom: '20px',
						height: '40px',
						cursor: 'pointer',
						transform: 'translateX(-50%)',
					}}
					src={Logo}
					alt='Logo'
				/>
			</a>
		</div>
	);
};

export default PricingPlans;
